import keys from '@/store/keys';

export default {
  set(key, obj) {
    window.localStorage.setItem(key, JSON.stringify(obj));
  },
  get(key) {
    // console.log(window.localStorage)
    // console.log(localStorage)

    let value = window.localStorage.getItem(key);
    if (typeof value === 'undefined' || value === null) {
      if (key === keys.userDataKey) {
        return this.get(keys.oldUserDataKey);
      }

      if (key === keys.tokenKey) {
        return this.get(keys.oldTokenKey);
      }

      return null;
    }

    if (value === null) {
      if (key === keys.userDataKey) {
        return this.get(keys.oldUserDataKey);
      }

      if (key === keys.tokenKey) {
        return this.get(keys.oldTokenKey);
      }

      return null;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  },
  remove(key, obj) {
    window.localStorage.removeItem(key);
  }
};
